export default __webpack_public_path__ + "static/media/04.fab00876.jpg";